export const BUS_BOOKING_FORM_CHANGE_PAX_DETAILS =
  'BUS/CHANGE_PAX_DETAILS_BOOKING_FORM';

export default function changePaxDetails(index, paxName) {
  return {
    type: BUS_BOOKING_FORM_CHANGE_PAX_DETAILS,
    index,
    details: {
      name: paxName,
    },
  };
}
